import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from '@mui/material';

export const SelectQuestion = ({ question, answer, onAnswerChange }) => {
  const options = question.q_options;
  const [isNA, setIsNA] = useState(answer === 'N/A');

  useEffect(() => {
    setIsNA(answer === 'N/A');
  }, [question.id]);

  if (!options || !Array.isArray(options)) return null;

  const handleChange = (event) => {
    onAnswerChange(event.target.value);
  };

  const handleNAChange = (e) => {
    const checked = e.target.checked;
    setIsNA(checked);
    onAnswerChange(checked ? 'N/A' : '');
  };

  return (
    <Box sx={{ width: '100%', margin: '0 auto' }}>
      <FormControl fullWidth disabled={isNA}>
        <InputLabel id={`select-label-${question.id}`}>Select an option</InputLabel>
        <Select
          label='Select an option'
          labelId={`select-label-${question.id}`}
          id={`select-${question.id}`}
          value={isNA ? '' : (answer || '')}
          onChange={handleChange}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ddd',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2aa1d3',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2aa1d3',
            },
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {options.map((option, index) => (
            <MenuItem key={`${option}-${index}`} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!question.required && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isNA}
              onChange={handleNAChange}
              sx={{
                color: '#ddd',
                '&.Mui-checked': { color: '#2aa1d3' },
              }}
            />
          }
          label="N/A"
          sx={{ mt: 1 }}
        />
      )}
    </Box>
  );
};